import Vue from "vue";
import Router from "vue-router";
import home from "@/view/home/index";
import homeEn from "@/view/home/index_en";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "_home",
      redirect: "/",
      component: home,
      children: [
        {
          path: "/",
          name: "download",
          meta: {
            title: "下载"
          },
          component: home
        }
      ]
    },
    {
      path: "/en",
      name: "_en",
      component: homeEn,
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js